const AnimateOnScroll = function ({ offset } = { offset: 10 }) {
  const windowTop = (offset * window.innerHeight) / 100;
  const windowBottom = window.innerHeight - windowTop;
  const windowLeft = 0;
  const windowRight = window.innerWidth;
  this.elements = [];
  this.start = (element) => {
    window.requestAnimationFrame(() => {
      element.style.animationDelay = element.dataset.animationDelay;
      element.style.animationDuration = element.dataset.animationDuration;
      element.querySelector('img').style.animationDelay = element.dataset.animationDelay;
      element.querySelector('img').style.animationDuration = element.dataset.animationDuration;
      element.classList.add(element.dataset.animation);
      element.dataset.animated = "true";
    });
  };
  this.inViewport = (element) => {
    const elementRect = element.getBoundingClientRect();
    const elementTop = elementRect.top + parseInt(element.dataset.animationOffset) || elementRect.top;
    const elementBottom = elementRect.bottom - parseInt(element.dataset.animationOffset) || elementRect.bottom;
    const elementLeft = elementRect.left;
    const elementRight = elementRect.right;
    return (elementTop <= windowBottom && elementBottom >= windowTop && elementLeft <= windowRight && elementRight >= windowLeft);
  };
  this.verifyElementsInViewport = (els = this.elements) => {
    for(let i = 0, len = els.length; i < len; i++){
      if(els[i].dataset.animated) continue;
      this.inViewport(els[i]) && this.start(els[i]);
    }
  };
  this.getElements = () => document.querySelectorAll("[data-animation]:not([data-animated])");
  this.update = () => {
    this.elements = this.getElements();
    this.elements && this.verifyElementsInViewport(this.elements);
  };
  window.addEventListener("load", this.update, false);
  window.addEventListener("scroll", () => this.verifyElementsInViewport(this.elements), { passive: true });
  window.addEventListener("resize", () => this.verifyElementsInViewport(this.elements), { passive: true });
};
const options = { offset: 15 };
const animation = new AnimateOnScroll(options);